import React, { useState } from 'react';
import { testimonials } from '../data/mock';
import { Quote, ChevronLeft, ChevronRight } from 'lucide-react';
import { Button } from './ui/button';

const TestimonialsSection = () => {
  const [index, setIndex] = useState(0);
  const total = testimonials.length;
  const current = testimonials[index];

  const prev = () => setIndex((i) => (i - 1 + total) % total);
  const next = () => setIndex((i) => (i + 1) % total);

  return (
    <section id="testimonials" className="bg-neutral-900 text-white">
      <div className="max-w-5xl mx-auto px-6 lg:px-10 py-24 md:py-32">
        <div className="text-center mb-16">
          <p className="text-white/60 text-xs uppercase tracking-[0.35em] mb-4">Client Voices</p>
          <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl font-bold tracking-tight">
            Testimonials
          </h2>
          <div className="mt-6 mx-auto w-16 h-px bg-white" />
        </div>

        <div className="relative">
          <Quote size={64} className="text-white/10 absolute -top-4 -left-2" />
          <div className="relative z-10 min-h-[320px]">
            <p className="text-lg md:text-xl leading-relaxed font-light whitespace-pre-line text-white/90">
              {current.text}
            </p>
            <div className="mt-10 pt-6 border-t border-white/20">
              <p className="font-serif text-2xl">{current.name}</p>
              <p className="text-white/60 text-sm mt-1">{current.location}</p>
            </div>
          </div>

          <div className="mt-10 flex items-center justify-between">
            <div className="flex gap-2">
              {testimonials.map((t, i) => (
                <button
                  key={`dot-${t.name}-${i}`}
                  onClick={() => setIndex(i)}
                  className={`h-1.5 transition-all duration-300 ${
                    i === index ? 'w-10 bg-white' : 'w-6 bg-white/30 hover:bg-white/50'
                  }`}
                  aria-label={`Testimonial ${i + 1}`}
                />
              ))}
            </div>
            <div className="flex gap-2">
              <Button
                variant="outline"
                onClick={prev}
                className="rounded-none border-white/40 text-white bg-transparent hover:bg-white hover:text-neutral-900 w-11 h-11 p-0"
              >
                <ChevronLeft size={18} />
              </Button>
              <Button
                variant="outline"
                onClick={next}
                className="rounded-none border-white/40 text-white bg-transparent hover:bg-white hover:text-neutral-900 w-11 h-11 p-0"
              >
                <ChevronRight size={18} />
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;
